class SearchLink extends HTMLElement {

    connectedCallback() {
        const innerText = this.getAttribute('title') || this.innerText;
        if(innerText === '') {
            document.addEventListener('DOMContentLoaded', function() {
                this.init(innerText);
            })
        } else this.init(innerText);
    }
    init(innerText){
        this.innerHTML = `
            <a style="color: var(--main-color, #0066CC) !important;text-decoration: none;cursor: pointer; z-index: 1">${innerText}</a>
        `
        const queryString = this.getQueryString();
        let pathName = window.location.pathname;
        const isSeoUrl = pathName.includes('realty-');
        const isNewBuilding = this.getAttribute('newbuilding');
        if(isSeoUrl) pathName = '/realty/search.html'
        if(isSeoUrl && isNewBuilding) pathName = '/realty/jk-search.html'
        if (!!window.location.search || isSeoUrl) {
            this.querySelector('a').setAttribute('href', `${pathName}?${queryString}`);
        } else {
            this.querySelector('a').setAttribute('href', `${pathName}#${queryString}`);
        }
        this.addEventListener('click', (e) => {
            e.stopPropagation();
        })
    }

    getQueryString(){
        const elementWithCianQuery = this.closest('[cian-query]');
        let query = "";
        if (elementWithCianQuery) {
            query = elementWithCianQuery.getAttribute('cian-query');
            query = query.replace(/district\[0]=[-0-9]+&?/, "");
            query = query.replace(/metro\[0]=[-0-9]+&?/, "");
            query = query.replace(/newobject\[0]=[-0-9]+&?/, "");
            query = query.replace(/railway\[0]=([-0-9]+)&?/, "");
            query = query.replace(/house\[0]=([-0-9]+)&?/, "");
            query = query.replace(/street\[0]=([-0-9]+)&?/, "");
            query = query.replace(/region=([-0-9]+)&?/, "");
        }

        let geoType = this.getAttribute('geo-type');
        if (geoType === 'underground') geoType = 'metro';
        if (geoType === 'location') {
            geoType = 'region';
        } else {
            geoType += '[0]';
        }
        return query + "&" + geoType + "=" + this.getAttribute('geo-id');
    }
};

if (!customElements.get('search-link')) customElements.define('search-link', SearchLink);


